(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-look')) {
    customElements.define(
      'campaign-look',
      class extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.campaign-look__trigger');
          this.panel = this.querySelector('.campaign-look__panel');
          if (!this.trigger || !this.panel) return;

          this.mask = this.querySelector('.campaign-look__mask');
          this.closeButton = this.querySelector('.campaign-look__close');
          this.onKeydown = (event) => {
            if (event.key === 'Escape') this.close();
          };

          this.trigger.addEventListener('click', () => this.toggle());
          if (this.mask) this.mask.addEventListener('click', () => this.close());
          if (this.closeButton) this.closeButton.addEventListener('click', () => this.close());

          if (window.Shopify && window.Shopify.designMode) {
            document.addEventListener('shopify:block:select', (event) => {
              if (event.target === this) this.open();
            });
            document.addEventListener('shopify:block:deselect', (event) => {
              if (event.target === this) this.close();
            });
          }
        }

        disconnectedCallback() {
          this.close();
        }

        get isOpen() {
          return this.hasAttribute('open');
        }

        toggle() {
          if (this.isOpen) {
            this.close();
          } else {
            this.open();
          }
        }

        open() {
          if (this.isOpen || !this.panel) return;
          document.querySelectorAll('campaign-look[open]').forEach((look) => {
            if (look !== this && typeof look.close === 'function') look.close();
          });
          this.setAttribute('open', '');
          this.trigger.setAttribute('aria-expanded', 'true');
          this.panel.setAttribute('aria-hidden', 'false');
          document.body.classList.add('campaign-look-open');
          document.addEventListener('keydown', this.onKeydown);
          if (this.closeButton) this.closeButton.focus();
        }

        close() {
          if (!this.isOpen || !this.panel) return;
          this.removeAttribute('open');
          this.trigger.setAttribute('aria-expanded', 'false');
          this.panel.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('campaign-look-open');
          document.removeEventListener('keydown', this.onKeydown);
          if (this.isConnected) this.trigger.focus();
        }
      }
    );
  }

  if (!customElements.get('campaign-video')) {
    customElements.define(
      'campaign-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          this.toggleButton = this.querySelector('.campaign-video__toggle');
          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;
          this.video.loop = true;
          if (this.dataset.poster) this.video.poster = this.dataset.poster;

          this.video.addEventListener('play', () => this.setPlaying(true));
          this.video.addEventListener('pause', () => this.setPlaying(false));
          this.video.addEventListener('ended', () => this.setPlaying(false));

          if (this.toggleButton) {
            this.toggleButton.addEventListener('click', () => {
              if (this.video.paused) {
                if (this.hasAttribute('data-sound')) this.video.muted = false;
                this.play();
              } else {
                this.video.pause();
              }
            });
          }

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.hasAttribute('data-autoplay') && reduceMotion) {
            this.video.removeAttribute('autoplay');
            this.video.pause();
            this.setAttribute('needs-tap', '');
          } else if (this.hasAttribute('data-autoplay')) {
            this.observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    this.play();
                  } else {
                    this.video.pause();
                  }
                });
              },
              { threshold: 0.25 }
            );
            this.observer.observe(this);
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        setPlaying(isPlaying) {
          if (isPlaying) {
            this.setAttribute('playing', '');
          } else {
            this.removeAttribute('playing');
          }
          if (this.toggleButton) {
            this.toggleButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
            this.toggleButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
          }
        }

        play() {
          const promise = this.video.play();
          if (promise && promise.then) {
            promise
              .then(() => this.removeAttribute('needs-tap'))
              .catch(() => this.setAttribute('needs-tap', ''));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-look')) {
    customElements.define(
      'campaign-look',
      class extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.campaign-look__trigger');
          this.panel = this.querySelector('.campaign-look__panel');
          if (!this.trigger || !this.panel) return;

          this.mask = this.querySelector('.campaign-look__mask');
          this.closeButton = this.querySelector('.campaign-look__close');
          this.onKeydown = (event) => {
            if (event.key === 'Escape') this.close();
          };

          this.trigger.addEventListener('click', () => this.toggle());
          if (this.mask) this.mask.addEventListener('click', () => this.close());
          if (this.closeButton) this.closeButton.addEventListener('click', () => this.close());

          if (window.Shopify && window.Shopify.designMode) {
            document.addEventListener('shopify:block:select', (event) => {
              if (event.target === this) this.open();
            });
            document.addEventListener('shopify:block:deselect', (event) => {
              if (event.target === this) this.close();
            });
          }
        }

        disconnectedCallback() {
          this.close();
        }

        get isOpen() {
          return this.hasAttribute('open');
        }

        toggle() {
          if (this.isOpen) {
            this.close();
          } else {
            this.open();
          }
        }

        open() {
          if (this.isOpen || !this.panel) return;
          document.querySelectorAll('campaign-look[open]').forEach((look) => {
            if (look !== this && typeof look.close === 'function') look.close();
          });
          this.setAttribute('open', '');
          this.trigger.setAttribute('aria-expanded', 'true');
          this.panel.setAttribute('aria-hidden', 'false');
          document.body.classList.add('campaign-look-open');
          document.addEventListener('keydown', this.onKeydown);
          if (this.closeButton) this.closeButton.focus();
        }

        close() {
          if (!this.isOpen || !this.panel) return;
          this.removeAttribute('open');
          this.trigger.setAttribute('aria-expanded', 'false');
          this.panel.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('campaign-look-open');
          document.removeEventListener('keydown', this.onKeydown);
          if (this.isConnected) this.trigger.focus();
        }
      }
    );
  }
if (!customElements.get('lookbook-scroller')) {
  customElements.define('lookbook-scroller', class extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.header-main');
      if (!this.header) return;
      this.update = () => this.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.update();
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.header);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-vimeo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-vimeo')) {
    customElements.define(
      'campaign-vimeo',
      class extends HTMLElement {
        connectedCallback() {
          this.src = this.dataset.src;
          this.media = this.querySelector('.campaign-vimeo__media');
          if (!this.src || !this.media || this.iframe) return;

          this.playButton = this.querySelector('.campaign-vimeo__play');
          if (this.playButton) {
            this.playButton.addEventListener('click', () => this.load('&autoplay=1'));
          }

          if (!this.hasAttribute('data-background')) return;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.removeAttribute('data-background');
            if (!this.playButton) this.load('');
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.load('&background=1&autoplay=1&loop=1&muted=1&autopause=0');
            },
            { rootMargin: '200px 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        load(params) {
          if (this.iframe) return;
          this.iframe = document.createElement('iframe');
          this.iframe.className = 'campaign-vimeo__iframe';
          this.iframe.src = this.src + params;
          this.iframe.title = this.dataset.title || '';
          this.iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          this.iframe.allowFullscreen = true;
          this.iframe.addEventListener('load', () => this.setAttribute('loaded', ''), { once: true });
          this.media.appendChild(this.iframe);
          this.setAttribute('playing', '');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-hero')) {
    customElements.define(
      'video-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;
          this.video.loop = true;

          this.playButton = this.querySelector('.video-hero__play');
          this.video.addEventListener('playing', () => this.markStarted());
          if (!this.video.paused && this.video.readyState > 2) this.markStarted();
          if (this.playButton) {
            this.playButton.addEventListener('click', () => this.play());
          }

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.removeAttribute('autoplay');
            this.video.pause();
            this.setAttribute('paused', '');
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.play();
                } else {
                  this.video.pause();
                }
              });
            },
            { threshold: 0.1 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        play() {
          const promise = this.video.play();
          if (!promise || !promise.then) {
            this.markStarted();
            return;
          }

          // NotAllowedError means the browser refused autoplay (iOS Low Power Mode, data saver);
          // AbortError only means a pause() interrupted the call, so the button stays hidden then.
          promise.then(
            () => this.markStarted(),
            (error) => {
              if (error && error.name === 'NotAllowedError') this.setAttribute('autoplay-blocked', '');
            }
          );
        }

        markStarted() {
          this.setAttribute('started', '');
          this.removeAttribute('autoplay-blocked');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
